document.addEventListener('DOMContentLoaded', function () {
    // Zmienne przechowujące elementy
    const openButton = document.querySelector('.header__button--open');
    const searchButton = document.querySelector('.header__button--search');
    const closeButton = document.querySelector('.menu-super__btn--close');
    const superMenu = document.querySelector('.menu-super');
    const bgForSidePanels = document.querySelector('.bg-for-side-panels');
    const searchInput = document.querySelector('.menu-super__search-input');

    // Funkcja otwierająca menu
    function openMenu() {
        if (superMenu) {
            superMenu.classList.add('menu-super--active');
        }
        if (bgForSidePanels) {
            bgForSidePanels.classList.add('bg-for-side-panels--active');
        }
    }

    // Funkcja zamykająca menu
    function closeMenu() {
        if (superMenu) {
            superMenu.classList.remove('menu-super--active');
        }
        if (bgForSidePanels) {
            bgForSidePanels.classList.remove('bg-for-side-panels--active');
        }
    }

    // Funkcja otwierająca menu i ustawiająca fokus na polu wyszukiwania
    function openMenuAndFocusSearch() {
        openMenu();
        if (searchInput) {
            searchInput.focus();
        }
    }

    // Przypisanie zdarzeń do przycisków
    if (openButton) {
        openButton.addEventListener('click', openMenu);
    }
    if (searchButton) {
        searchButton.addEventListener('click', openMenuAndFocusSearch);
    }
    if (closeButton) {
        closeButton.addEventListener('click', closeMenu);
    }
});
